import React from 'react';
import type { FC } from 'react';

import { useNotificationCount } from '@admin/hooks/use_notification_count';

export const NavBarNotificationCountBadge: FC = () => {
  const count = useNotificationCount();
  if (!count) return null;
  return <span className="badge badge-danger">{count}</span>;
};
